var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyAddressIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7375 21.4125C13.7375 22.8375 11.1875 24 7.99999 24C4.81249 24 2.26249 22.8375 2.26249 21.4125C2.26249 20.5125 3.27499 19.725 4.77499 19.275C5.29999 20.1 5.78749 20.8125 6.19999 21.3375C6.64999 21.9 7.32499 22.2375 8.03749 22.2375C8.78749 22.2375 9.46249 21.8625 9.83749 21.3C10.175 20.85 10.6625 20.1375 11.225 19.275C12.7625 19.725 13.7375 20.5125 13.7375 21.4125ZM7.99999 0C4.13749 0 0.987488 3.15 0.987488 7.0125C0.987488 11.0625 5.59999 18 7.36249 20.475C7.69999 20.925 8.37499 20.925 8.67499 20.475C10.4375 18 15.0125 11.0625 15.0125 7.0125C15.0125 3.15 11.8625 0 7.99999 0V0ZM10.175 7.3125C10.025 8.2875 9.27499 9.0375 8.33749 9.15C6.83749 9.375 5.59999 8.1 5.82499 6.6C5.97499 5.6625 6.72499 4.9125 7.66249 4.7625C9.16249 4.5375 10.4375 5.8125 10.175 7.3125V7.3125Z",
    fill: "#DB4D29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAddressIcon);
export default __webpack_public_path__ + "static/media/my-address-icon.00b36cc3ccc09d342f7479b085252978.svg";
export { ForwardRef as ReactComponent };